import React, { useState, useEffect } from 'react';
import videoImage from '../../assets/images/video-md.png';
import PropTypes from 'prop-types';
import './EventListingHero.css';
const backgroundImage = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1773292589/vectors-12_loogm2.png';

/**
 * Hero section component for Event Listing Page
 * This displays the banner/hero section with "Events Information" heading
 * The title is static as this page shows all events (not a specific event)
 * Based on the existing EventHeroBanner component pattern
 */
const EventListingHero = ({ categoryName, categoryId, description, className = '' }) => {
    // Default description if none provided
    const defaultDescription = "Choose between our Scientifically designed Residential Study Courses, 1-Day Workshops, Rational Poojas, Free Events and Machine Tests for holistic development and peace of mind.";
    
    const isPrenatal = categoryName && categoryName.toLowerCase().includes('prenat');
    const bgPosition = isPrenatal ? 'left center' : 'center';
    
    // Lazy load background image for better performance
    const [bgLoaded, setBgLoaded] = useState(false);
    
    useEffect(() => {
        const img = new Image();
        img.src = backgroundImage;
        img.onload = () => setBgLoaded(true);
    }, []);

    return (
        <section 
            className={`event-listing-hero ${className} ${bgLoaded ? 'event-listing-hero--loaded' : ''}`.trim()} 
            style={{ 
                backgroundImage: bgLoaded ? `url(${backgroundImage})` : 'none',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: bgPosition,
                backgroundSize: 'cover'
            }}
        >
            <div className="event-listing-hero__content">
                <div className="event-listing-hero__header">
                    {/* Icon - Video Testimonials image */}
                    <div className="event-listing-hero__icon" style={{ marginTop: '1.5rem' }}>
                        <img src={videoImage} alt="Video Icon" />
                    </div>
                    
                    {/* Heading */}
                    <h1 className="event-listing-hero__title" style={{ marginTop: '1.5rem' }}>
                        {categoryName || 'Events Information'}
                    </h1>
                </div>
                
                {/* Description */}
                <p className="event-listing-hero__description">
                    {description || defaultDescription}
                </p>
            </div>
            
            {/* Decorative Elements */}
            <div className="event-listing-hero__decoration">
                {/* Top-left leaf cluster */}
                <svg className="event-listing-hero__leaf event-listing-hero__leaf--top-left" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                    <path d="M30,60 Q40,40 60,45 Q50,55 45,70 Z" fill="currentColor" opacity="0.3"/>
                    <path d="M40,70 Q50,50 70,55 Q60,65 55,80 Z" fill="currentColor" opacity="0.3"/>
                    <path d="M25,75 Q35,55 55,60 Q45,70 40,85 Z" fill="currentColor" opacity="0.3"/>
                </svg>
                
                {/* Top-center-right leaf cluster */}
                <svg className="event-listing-hero__leaf event-listing-hero__leaf--top-center" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                    <path d="M40,50 Q50,30 70,35 Q60,45 55,60 Z" fill="currentColor" opacity="0.3"/>
                    <path d="M50,60 Q60,40 80,45 Q70,55 65,70 Z" fill="currentColor" opacity="0.3"/>
                </svg>
                
                {/* Bottom-right large fern */}
                <svg className="event-listing-hero__leaf event-listing-hero__leaf--bottom-right" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100,20 Q80,50 70,80 Q75,70 85,60 Q80,75 75,90 Q80,85 90,75 Q85,90 80,105 Q85,100 95,90 Q90,105 85,120" 
                          stroke="currentColor" strokeWidth="2" fill="none" opacity="0.3"/>
                    <path d="M100,20 Q120,50 130,80 Q125,70 115,60 Q120,75 125,90 Q120,85 110,75 Q115,90 120,105 Q115,100 105,90" 
                          stroke="currentColor" strokeWidth="2" fill="none" opacity="0.3"/>
                    <path d="M100,20 L100,130" stroke="currentColor" strokeWidth="3" opacity="0.3"/>
                </svg>
                
                {/* Bottom-center-left small leaf */}
                <svg className="event-listing-hero__leaf event-listing-hero__leaf--bottom-left" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <path d="M50,30 Q40,50 35,70 Q45,60 50,50 Q45,65 40,80" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.3"/>
                    <path d="M50,30 Q60,50 65,70 Q55,60 50,50" stroke="currentColor" strokeWidth="2" fill="none" opacity="0.3"/>
                </svg>
            </div>
        </section>
    );
};

EventListingHero.propTypes = {
    categoryName: PropTypes.string,
    categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    description: PropTypes.string,
    className: PropTypes.string,
};

EventListingHero.defaultProps = {
    categoryName: 'Events Information',
    categoryId: '',
    description: '',
    className: '',
};

export default EventListingHero;

